import { DocumentField } from "types/Models/task";

type ServerDocument = DocumentField["documents"][number];

const isServerDocument = (document: unknown): document is ServerDocument => {
  if (!document || typeof document !== "object") {
    return false;
  }

  if ("path" in document || "relativePath" in document) {
    return false;
  }

  if (!("uuid" in document)) {
    return false;
  }

  const { uuid } = document;

  return typeof uuid === "string" && Boolean(uuid);
};

export const filterServerDocuments = (documents: unknown): ServerDocument[] => {
  if (!Array.isArray(documents)) {
    return isServerDocument(documents) ? [documents] : [];
  }

  return documents.filter(isServerDocument);
};
